import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useClubLocations(clubId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.clubPortal.clubLocations(clubId ?? ""),
		queryFn: () => clubApi.clubLocations.list(clubId as string),
		enabled: !!clubId,
	});
}

export function useCreateClubLocation(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (data: { name: string; address?: string | null; sort_order?: number }) =>
			clubApi.clubLocations.create(clubId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.clubLocations(clubId),
			});
		},
	});
}

export function useUpdateClubLocation(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			locationId,
			data,
		}: {
			locationId: string;
			data: { name?: string; address?: string | null; sort_order?: number };
		}) => clubApi.clubLocations.update(clubId, locationId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.clubLocations(clubId),
			});
		},
	});
}

export function useDeleteClubLocation(clubId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (locationId: string) => clubApi.clubLocations.delete(clubId, locationId),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.clubLocations(clubId),
			});
		},
	});
}
